<template>
  <el-dialog
    :title="$t('app.details')"
    :visible.sync="dialogVisible"
    width="1000px"
    class="pre-new-stu-details"
  >
    <div style="height: 600px; overflow: auto">
      <el-form label-width="100px" label-position="top" size="small">
        <div class="person-info" style="margin-bottom: 20px">
          <h3>{{ $t("app.personalInfo") }}</h3>
          <el-divider></el-divider>
          <el-col :span="12" style="height: 85px">
            <el-form-item :label="$t('app.applicationNumber')">
              <el-input
                v-model="info.applicationNumber"
                :disabled="true"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height: 85px">
            <el-form-item :label="$t('app.gender')">
              <el-input v-model="info.gender" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.surname')">
              <el-input v-model="info.lastName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.firstName')">
              <el-input v-model="info.firstName" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.chineseName')">
              <el-input v-model="info.nameChina" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.countryDialCode')">
              <el-input v-model="info.nationCode" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.mobilePhoneNumber')">
              <el-input v-model="info.mobile" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('app.emailAddress')">
              <el-input v-model="info.email" :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-form-item :label="$t('app.applyView.originalInstitution')">
            <el-input
              v-model="info.originalSchool"
              style="width: 40%"
              :disabled="true"
            ></el-input>
          </el-form-item>
        </div>
        <div class="application-form">
          <h3>{{ $t("app.applicationForAccommodation") }}</h3>
          <el-divider></el-divider>
          <el-form-item :label="$t('app.applyView.roomChoose')">
            <el-radio-group v-model="info.selectedRoomType" :disabled="true">
              <!-- <el-radio :label="'1'">{{ $t("app.applyView.single") }}</el-radio>
              <br />
              <el-radio :label="'2'">{{ $t("app.applyView.double") }}</el-radio> -->
              <el-radio :label="'1'">{{
                $t("app.roomTypeSelect.noI")
              }}</el-radio
              ><br />
              <el-radio :label="'2'">{{
                $t("app.roomTypeSelect.noII")
              }}</el-radio
              ><br />
              <el-radio :label="'3'">{{
                $t("app.roomTypeSelect.noIII")
              }}</el-radio
              ><br />
              <el-radio :label="'4'">{{
                $t("app.roomTypeSelect.noIIII")
              }}</el-radio>
              <br />
              <el-radio :label="'5'">{{
                $t("app.roomTypeSelect.noIIIII")
              }}</el-radio>
              <br />
              <el-radio :label="'6'">{{
                $t("app.roomTypeSelect.noIIIIII")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('app.applyView.roommate')">
            <el-radio-group
              v-model="info.selectedRoomMateType"
              :disabled="true"
            >
              <el-radio :label="'1'">{{
                $t("app.noSpecialPreference")
              }}</el-radio>
              <br />
              <el-radio :label="'2'">{{
                $t("app.studentsFromTheirCountryOrRegion")
              }}</el-radio>
              <br />
              <el-radio :label="'3'">{{
                $t("app.internationalStudentsFromOtherRegions")
              }}</el-radio>
              <br />
              <el-radio :label="'4'">{{
                $t("app.exchangeStudentsFromOtherInstitutions")
              }}</el-radio>
              <br />
              <el-radio :label="'5'">{{
                $t("app.exchangeStudentsFromTheirInstitutions")
              }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('app.applyView.other')">
            <el-input
              :disabled="true"
              type="textarea"
              :autosize="{ minRows: 4 }"
              v-model="info.requirement"
              style="width: 600px"
            ></el-input>
          </el-form-item>

          <div class="date-content">
            <h3>{{ $t("app.arriveInMacau") }}</h3>
            <el-divider></el-divider>
            <el-col :span="12">
              <el-form-item :label="$t('app.dateOfArrivalInMacao')">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="info.arrivalDate"
                  style="width: 200px"
                  :disabled="true"
                ></el-date-picker>
              </el-form-item>
            </el-col>
           
            <el-col :span="12">
              <el-form-item :label="$t('app.timeOfArrivalInMacao')">
                <el-time-picker
                  value-format="HH:mm"
                  format="HH:mm"
                  v-model="info.planArrivalTime"
                  style="width: 200px"
                  :disabled="true"
                ></el-time-picker>
              </el-form-item>
            </el-col>
            <!-- <el-form-item :label="$t('app.applyView.serve')">
              <el-radio-group v-model="info.meetService" :disabled="true">
                <el-radio :label="'1'">{{
                  $t("app.applyView.serveI")
                }}</el-radio>
                <br />
                <el-radio :label="'2'">{{
                  $t("app.applyView.serveII")
                }}</el-radio>
              </el-radio-group>
            </el-form-item> -->
            <el-form-item :label="$t('app.portOfArrival')">
              <el-radio-group v-model="info.meetAddress" :disabled="true">
                <template v-for="p in port">
                  <el-radio
                    :label="p.value"
                    :key="p.value"
                    style="display: block"
                    >{{ p.label }}</el-radio
                  >
                </template>
              </el-radio-group>
            </el-form-item>
            <div v-if="info.meetAddress === 'arrival_air'" style="width: 100%">
              <el-form-item :label="$t('app.applyView.departurePort')">
                <el-input
                  v-model="info.departurePort"
                  :disabled="true"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('app.applyView.leaveDate')">
                <el-date-picker
                  type="date"
                  value-format="yyyy-MM-dd"
                  v-model="info.departureDate"
                  style="width: 200px"
                  :disabled="true"
                ></el-date-picker>
              </el-form-item>
              <el-form-item :label="$t('app.applyView.leaveTime')">
                <el-time-picker
                  value-format="HH:mm"
                  format="HH:mm"
                  v-model="info.departureTime"
                  style="width: 200px"
                  :disabled="true"
                ></el-time-picker>
              </el-form-item>
              <el-form-item :label="$t('app.applyView.flightNumber')">
                <el-input
                  v-model="info.filghtNumber"
                  :disabled="true"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="info" @click="dialogVisible = false">{{
        $t("app.cancel")
      }}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getPort } from "@/api/newStudent";
export default {
  data() {
    return {
      dialogVisible: false,
      info: {},
      port: []
    };
  },
  created() {
    getPort().then(res => {
      this.port = res.data.map(_ => {
        return {
          value: _.DictCode,
          label: _.DictText
        };
      });
    });
  },
  methods: {
    edit(row) {
      this.dialogVisible = true;
      this.info = JSON.parse(JSON.stringify(row));
    }
  }
};
</script>
<style lang="scss">
.pre-new-stu-details {
  .person-info,
  .application-form,
  .date-content {
    .el-form-item__content {
      padding: 0 15px;
    }
    .el-input {
      width: 300px;
    }
    .el-radio {
      margin-bottom: 6px;
    }
  }
}
</style>
